
import { Component, Prop, Vue } from 'vue-property-decorator'
import {
  formatUserNameWithRemark,
  pickUserDisplayName,
  pickUserStoreRemark,
} from '@/utils/userNameDisplay'

@Component({ name: 'UserNameRemark' })
export default class extends Vue {
  /** 整行对象（优先）：自动取 name/userName/consignee + userRemark（默认不回落订单 remark） */
  @Prop({ default: null }) readonly row!: any
  /** 直接传姓名 */
  @Prop({ default: '' }) readonly name!: string
  /** 直接传本店备注 */
  @Prop({ default: '' }) readonly remark!: string
  /** 用户列表等：remark 字段就是本店备注 */
  @Prop({ type: Boolean, default: false }) readonly preferRemark!: boolean
  /** 自定义姓名字段优先级 */
  @Prop({
    default: () => ['name', 'userName', 'consignee'],
  })
  readonly nameKeys!: string[]

  get displayName(): string {
    if (this.name) {
      return formatUserNameWithRemark(this.name, this.remark).name
    }
    const n = pickUserDisplayName(this.row, this.nameKeys)
    return formatUserNameWithRemark(n, '').name
  }

  get displayRemark(): string {
    if (this.remark) return String(this.remark).trim()
    if (this.name && !this.row) return ''
    return pickUserStoreRemark(this.row, { preferRemark: this.preferRemark })
  }
}
